export default {
  Region: 'ap-northeast-1',
  UserPoolId: 'ap-northeast-1_8SubIzcsi',
  ClientId: '6f4bipnfkqm7d7f48o7ulf4nvn',
  Storage: sessionStorage,
  IdentityPoolId: 'ap-northeast-1:418992177046:userpool/ap-northeast-1_8SubIzcsi'
}


// WEBPACK FOOTER //
// ./src/config.js